'use client';

import { useFormStatus } from 'react-dom';
import clsx from 'clsx';

export default function SubmitButton({
    title,
    locale,
    disabled,
}: Readonly<{
    title: string;
    locale: string;
    disabled: boolean;
}>) {
    const { pending } = useFormStatus();

    return (
        <button
            className={clsx(
                'flex h-full w-full items-center rounded-[64px] bg-[#6C49FF] px-[18px] hover:bg-[#7B5BFF] active:bg-[#6C49FF] disabled:bg-[#CCCCCC]',
                {
                    'justify-center': !pending,
                    'justify-between ': pending,
                },
            )}
            aria-disabled={pending}
            disabled={pending || disabled}
        >
            <svg
                className={clsx('animate-spin', {
                    hidden: !pending,
                    block: pending,
                })}
                viewBox="0 0 1024 1024"
                version="1.1"
                xmlns="http://www.w3.org/2000/svg"
                width="30"
                height="30"
            >
                <path
                    d="M512 160a352 352 0 1 0 0 704 352 352 0 0 0 0-704z m0 64a288 288 0 1 1 0 576 288 288 0 0 1 0-576z"
                    fill="#808080"
                    fillOpacity=".3"
                ></path>
                <path
                    d="M834.56 370.944a352 352 0 0 1-308.48 492.8l-14.08 0.256v-64a288 288 0 0 0 270.272-387.712l-6.272-15.68 58.624-25.6z"
                    fill="#1296db"
                ></path>
            </svg>
            <div className={clsx('j-t1 text-white')}>{title}</div>
        </button>
    );
}
